module.exports = __webpack_public_path__ + "media/giving-back/circular-65f8975e.png";